import React from "react";

const Incentives = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Incentives / Facilities To Growers</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <p>
          The Corporation gives a number of incentives and facilities to the
          seed growers which are as under:-
        </p>

        <ol>
          <li className="mb-2">
            A premium of 30 &mdash; 35% premium over &amp; above average of 5
            highest mandi rates / MSP (whichever is higher) is given to the seed
            growers for the procurement of certified seed of Paddy,&nbsp;pulses
            &amp; Oil seeds
          </li>
          <li className="mb-2">
            In case of wheat procurement, HSDC gives Rs.325/- per quintal higher
            than the Govt. Minimum Support Price including Bonus.&nbsp;In case
            of C-306 variety, an additional premium of Rs.300/- per qtl.&nbsp;is
            given.
          </li>
          <li className="mb-2">
            The amount of Rs.12/- per qtl. is extra to the Shareholder Growers
            on Certified Seed of Wheat.
          </li>
          <li className="mb-2">
            85% procurement price of the Raw seed is paid immediately at the
            time of delivery of raw seed.
          </li>
          <li className="mb-2">
            Gunny bags are provided to growers for bringing the produce to the
            processing plants.
          </li>
          <li className="mb-2">
            Transportation rebate upto Rs. 25.75/- per qtl. is given on
            certified seed.
          </li>
          <li className="mb-2">
            Unloading expenses of raw seed at the processing plants is borne by
            HSDC.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Incentives;
